import styled, { css } from 'styled-components';
import { TextStyle } from 'components/text';
import { device, spacing } from 'commons';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const TittleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 15px;

  @media (max-width: ${device.mobile}px) {
    flex-direction: column;
  }
`;

const OptionButton_selected = css`
  border-color: ${({ theme }) => theme.primary_300};
  background-color: ${({ theme }) => theme.primary_300};
  color: ${({ theme }) => theme.neutral_100};
  cursor: default;
`;

const OptionButton_notSelected = css`
  &:hover {
    background-color: ${({ theme }) => theme.neutral_200};
  }
`;

const positions = {
  start: css`
    border-radius: ${spacing.input.borderRadius} 0px 0px
      ${spacing.input.borderRadius};
    border-right: unset;
  `,
  end: css`
    border-radius: 0px ${spacing.input.borderRadius}
      ${spacing.input.borderRadius} 0px;
    border-left: unset;
  `,
};

export const OptionButton = styled.button<{
  $selected: boolean;
  $position: 'start' | 'end';
}>`
  font-weight: 300;
  font-size: 12px;
  padding: 13px 20px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.neutral_100};
  color: ${({ theme }) => theme.neutral_500};
  border: 1px solid ${({ theme }) => theme.neutral_300};

  ${({ $position }) => positions[$position]}
  ${({ $selected }) =>
    $selected ? OptionButton_selected : OptionButton_notSelected}
`;

export const OptionButtonsWrapper = styled.div`
  display: flex;
  width: fit-content;
  height: ${spacing.input.height};
  overflow: hidden;
`;

export const InputWrapper = styled.div<{ $small?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;

  .hint-container {
    display: flex;
    align-items: center;
    gap: 5px;
    flex: 1;

    .input {
      width: 250px;
      flex: unset;

      @media (max-width: ${device.mobile}px) {
        width: 100%;
      }
    }
  }

  ${({ $small }) =>
    $small &&
    css`
      width: 250px;
      flex: unset;
    `}

  @media (max-width: ${device.mobile}px) {
    width: 100% !important;
  }
`;

export const ButtonWrapper = styled.div`
  align-self: end;

  ${TextStyle} {
    text-align: center;
    width: 200px;
  }
`;
